import styled from 'styled-components';
import { Grid, Button } from '@simplywallst/ui-core';

export const RegistrationOverlay = styled(Grid)`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const RegistrationButton = styled(Button)`
  width: max-content;
`;
